/**
 * 
 */
(function() {
	"use strict";
	angular.module("cbl.finanza.mf").service("FinDomainSrvc", [ '$http', '$q', 'FinMessaggiFctr', 'FIN_CONSTANTS', function($http, $q, messaggiFctr, CONSTANTS) {
		this.domains = {};

		this.getDomain = function(domain, skipBlank) {
			if (this.domains === undefined) {
				this.domains = {};
			}
			if (this.domains[domain] === undefined || this.domains[domain].length === 0) {
				// chiamata Rest al servizio di recupero dominio in caso non sia
				// gia' memorizzato
				var self = this;
				$http({
					method : "GET",
					url : CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.DOMAIN,
					params : {
						table : domain.toUpperCase()
					}
				}).then(function(response) {
					if (messaggiFctr.processaResponse(response)) {
						return;
					}
					self.domains[domain] = [];
					if (!skipBlank) {
						self.domains[domain].push({
							cod : "",
							dsc : "Seleziona..."
						});
					}
					for ( var i in response.data.result) {
						self.domains[domain].push(response.data.result[i]);
					}

				}, function(reason) {
					messaggiFctr.processaResponse(reason);
				});
			}
			return this.domains[domain];
		};

		this.promiseDomain = function(domain) {
			var deferred = $q.defer();

			if (this.domains[domain] === undefined) {
				var self = this;
				$http({
					method : "GET",
					url : CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.DOMAIN,
					params : {
						table : domain.toUpperCase()
					}
				}).then(function(response) {
					if (messaggiFctr.processaResponse(response)) {
						return;
					}
					self.domains[domain] = [];

					for ( var j in response.data.result) {
						self.domains[domain].push(response.data.result[j]);
					}

					deferred.resolve(self.domains[domain]);
				}, function(reason) {
					deferred.reject(reason);
					messaggiFctr.processaResponse(reason);
				});
			} else {
				deferred.resolve(this.domains[domain]);
			}

			return deferred.promise;
		};

		this.promiseCascading = function(domain, cascading, skipBlank) {
			var deferred = $q.defer();

			var self = this;
			var cascadingDomain = [];
			$http({
				method : "GET",
				url : CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.DOMAIN,
				cache : true,
				params : {
					table : domain.toUpperCase(),
					params : cascading
				}
			}).then(function(response) {
				if (messaggiFctr.processaResponse(response)) {
					deferred.reject(response);
					return;
				}
				if (!skipBlank) {
					cascadingDomain.push({
						cod : "",
						dsc : "Seleziona..."
					});
				}
				for ( var i in response.data.result) {
					cascadingDomain.push(response.data.result[i]);
				}
				deferred.resolve(cascadingDomain);
			}, function(reason) {
				messaggiFctr.processaResponse(reason);
				deferred.reject(reason);
			});

			return deferred.promise;
		};

		this.promiseEccezioni = function(domain, cascading, skipBlank) {
			var deferred = $q.defer();

			var self = this;
			var cascadingDomain = [];
			$http({
				method : "GET",
				url : CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.DOMAIN,
				cache : true,
				params : {
					table : domain.toUpperCase(),
					params : cascading
				}
			}).then(function(response) {
				if (messaggiFctr.processaResponse(response)) {
					deferred.reject(response);
					return;
				}
				if (!skipBlank) {
					cascadingDomain.push({
						cod : "",
						dsc : "Seleziona..."
					});
				}
				for ( var i in response.data.result) {
					cascadingDomain.push(response.data.result[i]);
				}
				deferred.resolve({
					cod : cascading,
					ecz : cascadingDomain
				});
			}, function(reason) {
				messaggiFctr.processaResponse(reason);
				deferred.reject(reason);
			});

			return deferred.promise;
		};

		this.getLabel = function(domain, key) {
			if (!this.domains) {
				return "";
			}
			var array = this.domains[domain];
			if (!array) {
				return "";
			}
			for ( var i in array) {
				if (array[i].cod === key) {
					return array[i].dsc;
				}
			}
			return "";
		};

	} ]);
}());


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/servicesUtilities/finDomainSrvc.js
 ** module id = 26
 ** module chunks = 0 1 2
 **/